import { writable } from 'svelte/store'

type WebSession = {
	pagesVisited: number
	timeMounted: number
	timeNavigated: number
	getTimeSinceMounted: () => number
	getTimeSinceNavigated: () => number
}

export default writable<WebSession>({
	pagesVisited: 0,
	timeMounted: Date.now(),
	timeNavigated: Date.now(),
	getTimeSinceMounted() {
		return (Date.now() - this.timeMounted) / 1000
	},
	getTimeSinceNavigated() {
		return (Date.now() - this.timeNavigated) / 1000
	}
})
